module.exports = __webpack_public_path__ + "static/media/note_svg.c2ce899f.svg";